module.exports = __webpack_public_path__ + "img/zdd_home_banner_user.80a92784.png";